import * as React from "react";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { PerformanceMethod } from "../../../../../../../Wrap/Constants/Enums/Domain/PerformanceMethod";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { InvestorType } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { ProductsValuationDetailSummary } from "../../../../../../../Wrap/Models/Domains/Valuation/ProductsValuationDetailSummary";
import { PortfolioPerformanceSummaryModel } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/PortfolioPerformanceSummaryModel";
import { ProductPerformanceModel } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/ProductPerformanceModel";
import { LoadingSkeletonType } from "../../../../../../Shared/LoadingSkeleton/Contents";
import { LoadingSkeleton } from "../../../../../../Shared/LoadingSkeleton/LoadingSkeleton";
import { AccountsSummaryTable } from "./Components/AccountsSummaryTable";
import { CircleChart } from "./Components/CircleChart";
import { AccountCards } from "./Components/AccountCards";
import { PortfolioDashboardMultiSelectionStore, PortfolioDashboardStore } from "../../Store/Variable";
import { IPortfolioDashboardComponentProps, PortfolioDashboardComponent } from "../Common/PortfolioDashboardComponent";
import { getSelectedHeadAccount } from "../Common/PortfolioDashboardHelper";
import { PresentationContext } from "../Common/PresentationViewWrapper";
import { PortfolioDashboardSummaryAction } from "./Action/Action";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../../Urls";
import { ContextStore } from "../../../../../../../react-core/Flux/Variables";
import { ContextType } from "../../../../../../../Wrap/Constants/Enums/ContextType";
import { DateRange } from "../../../../../../Shared/Components/DateRange";
import { checkPermission } from "../../../../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../../../../Wrap/Constants/Enums/UserClaim";
import AdviserSiteTagManager from "../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { UserStore } from "../../../../../Stroes/Variable";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { portfolioDashboardTabEnum } from "../../Resource/Content";
import { TransactionEnum } from "../Transactions/Resource/Contents";
import {
    PortfolioPerformanceSummaryDispatcher,
    PortfolioPerformanceSummaryQuery,
    PortfolioPerformanceSummaryStore,
    ProductsValuationDetailSummaryDispatcher,
    ProductsValuationDetailSummaryQuery,
    ProductsValuationDetailSummaryStore,
    SummaryTrustDetailsDisaptcher,
    SummaryTrustDetailsStore,
} from "./Store/Variable";
import { AssetClassType } from "../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { ActionType } from "../../../../../../../react-core/Flux/ActionType";
import { stripToDay } from "../../../../../../../react-core/utils/date";

interface IPortfolioDashboardSummaryState {
    dateSelect?: Date;
    isProductValuationLoading?: boolean;
    detailsSummary?: ProductsValuationDetailSummary;
    slideNumber: number;
    portfolioPerformanceSummaries?: Map<string, PortfolioPerformanceSummaryModel>;
}

interface IPortfolioDashboardSummaryProps extends IPortfolioDashboardComponentProps {
    ProductOverviewNavigate: (SubClAccountId: string) => void;
}

export class PortfolioDashboardSummary extends PortfolioDashboardComponent<
    IPortfolioDashboardSummaryProps,
    IPortfolioDashboardSummaryState
> {
    constructor(props: IPortfolioDashboardSummaryProps) {
        super(props);

        this.subscribeToStore(ProductsValuationDetailSummaryStore, () =>
            this.onProductsValuationDetailSummaryChanged()
        );
        this.subscribeToStore(PortfolioPerformanceSummaryStore, () => this.onPortfolioPerformanceSummaryChanged());
    }

    private onPortfolioPerformanceSummaryChanged() {
        const selectedSubAccountHierarchyIds = PortfolioDashboardMultiSelectionStore.getData() || [];
        const allAccounts: ClientAccount[] = PortfolioDashboardStore.getData() || [];
        const selectedHeadAccount = getSelectedHeadAccount(selectedSubAccountHierarchyIds, allAccounts);

        const { portfolioPerformanceSummaries } = this.state;

        selectedHeadAccount.forEach((headAccount) => {
            const query = this.getPortfolioPerformanceSummaryQuery(headAccount);
            const data = PortfolioPerformanceSummaryStore.getPayload(query);

            if (data != null && !portfolioPerformanceSummaries.has(headAccount)) {
                portfolioPerformanceSummaries.set(headAccount, data);
            }
        });

        this.setState({ portfolioPerformanceSummaries: portfolioPerformanceSummaries });
    }

    private onProductsValuationDetailSummaryChanged() {
        const query: ProductsValuationDetailSummaryQuery = this.getProductsValuationDetailSummaryQuery();
        const data: ProductsValuationDetailSummary = ProductsValuationDetailSummaryStore.getPayload(query);

        if (ProductsValuationDetailSummaryStore.isLoadingForQuery(query) || data == null) {
            this.setState({ isProductValuationLoading: true });
        } else {
            this.setState({ detailsSummary: data, isProductValuationLoading: false });
        }
    }

    initState() {
        this.state = {
            dateSelect: new Date(),
            isProductValuationLoading: true,
            detailsSummary: null,
            slideNumber: 0,
            portfolioPerformanceSummaries: new Map<string, PortfolioPerformanceSummaryModel>(),
        };
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    componentDidMount() {
        super.componentDidMount();
        const indexIsBtnPresentationClicked = Object.keys(portfolioDashboardTabEnum).indexOf(
            portfolioDashboardTabEnum.Summary
        );
        if (this.props.isBtnPresentationClicked[indexIsBtnPresentationClicked]) {
            this.props.onPresentationViewStatusChange(
                portfolioDashboardTabEnum.Summary,
                this.props.isBtnPresentationClicked
            );
        } else {
            this.addEvent({
                environment: {
                    appType: "web",
                    setting: "prod",
                    timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
                },
                page: {
                    pageUrl: Urls.get()
                        .main.PortfolioDashboard({
                            hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                HierarchyLevelName.Customer,
                                this.props.customerid
                            ),
                        })
                        .summary.getUrl(),
                    pageTitle: `${document.title} - client - summary`,
                },
                user: {
                    loginId: UserStore.getUserInfo()?.ClientId.toString(),
                    internal: "yes",
                },
                event: "pageLoaded",
            });
        }
    }

    private getProductsValuationDetailSummaryQuery(): ProductsValuationDetailSummaryQuery {
        const { dateSelect } = this.state;
        const selectedSubAccountHierarchyIds = PortfolioDashboardMultiSelectionStore.getData() || [];
        const allAccounts: ClientAccount[] = PortfolioDashboardStore.getData() || [];
        const _date = JsonDateParser.toJsonDateNoOffset(new Date(dateSelect.getFullYear(), dateSelect.getMonth(), dateSelect.getDate())) as any;
        const selectedHeadAccount = getSelectedHeadAccount(selectedSubAccountHierarchyIds, allAccounts);

        const query: ProductsValuationDetailSummaryQuery = {
            subAccountHierarchyIds: [...selectedSubAccountHierarchyIds].sort(),
            headAccountHierarchyIds: [...selectedHeadAccount].sort(),
            asAt: _date,
            assetClassType: AssetClassType.Tier1,
        };

        return query;
    }

    private getPortfolioPerformanceSummaryQuery(headAccount: string): PortfolioPerformanceSummaryQuery {
        let now = new Date();
        now = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const lastYear = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate() + 1);

        return {
            hierarchyId: headAccount,
            fromDateTime: JsonDateParser.toJsonDateNoOffset(lastYear),
            toDateTime: JsonDateParser.toJsonDateNoOffset(now),
            fromInception: false,
            performanceMethod: PerformanceMethod.Simple,
        };
    }

    getData() {
        const query = this.getProductsValuationDetailSummaryQuery();

        const allAccounts: ClientAccount[] = PortfolioDashboardStore.getData() || [];

        const trustSelectedHeadAccount = allAccounts
            .filter(
                (ele) =>
                    query.headAccountHierarchyIds.includes(ele.HierarchyId) && ele.InvestorType == InvestorType.Trust
            )
            .map((ele) => ele.HierarchyId)
            .sort();

        if (trustSelectedHeadAccount.length > 0) {
            if (SummaryTrustDetailsStore.isEmptyForQuery(trustSelectedHeadAccount)) {
                PortfolioDashboardSummaryAction.getTrustDetails(trustSelectedHeadAccount);
            } else {
                SummaryTrustDetailsDisaptcher.dispatch({
                    actionType: ActionType.Success,
                    payload: SummaryTrustDetailsStore.getPayload(trustSelectedHeadAccount),
                    query: trustSelectedHeadAccount,
                });
            }
        }

        if (ProductsValuationDetailSummaryStore.isEmptyForQuery(query)) {
            PortfolioDashboardSummaryAction.getProductsValuationDetailSummary(query);
        } else {
            ProductsValuationDetailSummaryDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: ProductsValuationDetailSummaryStore.getPayload(query),
                query: query,
            });
        }

        query.headAccountHierarchyIds.forEach((headAccount) => {
            const query = this.getPortfolioPerformanceSummaryQuery(headAccount);

            if (PortfolioPerformanceSummaryStore.isEmptyForQuery(query)) {
                PortfolioDashboardSummaryAction.getPerformanceSummary(query);
            } else {
                PortfolioPerformanceSummaryDispatcher.dispatch({
                    actionType: ActionType.Success,
                    payload: PortfolioPerformanceSummaryStore.getPayload(query),
                    query: query,
                });
            }
        });
    }

    private renderPieChartAndAccountTable(): JSX.Element {
        const { detailsSummary, isProductValuationLoading } = this.state;
        if (isProductValuationLoading) {return <LoadingSkeleton type={LoadingSkeletonType.PieChartAndTable} />;}

        const pieChart = (
            <CircleChart chartId={"product-valuation-summary"} chartType={"pie"} chartData={detailsSummary.Products} />
        );
        return (
            <div className="row">
                {pieChart.props.chartData && pieChart.props.chartData.length ? (
                    <div className="col-12 col-md-auto">
                        <div className="account-validation-pie-chart">{pieChart}</div>
                    </div>
                ) : null}
                <div className="col-12 col-md-fluid pb-24">{this.renderAccountTable()}</div>
            </div>
        );
    }

    private renderAccountTable(): JSX.Element {
        const { detailsSummary, dateSelect, portfolioPerformanceSummaries } = this.state;
        const productPerformanceSummaries: ProductPerformanceModel[] = [];
        portfolioPerformanceSummaries.forEach((value, key) =>
            value.ProductPerformanceSummary.forEach((summary) => productPerformanceSummaries.push(summary))
        );
        const allAccounts: ClientAccount[] = PortfolioDashboardStore.getData() || [];
        var subAccounts = allAccounts[0]?.SubAccounts

        return (
            <AccountsSummaryTable
                detailsSummary={detailsSummary.Products}
                dateSelect={dateSelect}
                onDateChange={(val: Date) => {
                    this.setState({ dateSelect: val}, () => {
                        this.getData();
                    });
                }}
                productPerformanceList={productPerformanceSummaries}
                hasReadWriteAccessToAdviser={this.props.hasReadWriteAccessToAdviser}
                isPresentationClicked={this.props.isBtnPresentationClicked}
                onPresentationStatusChange={this.props.onPresentationViewStatusChange}
                subAccountData={subAccounts}
            />
        );
    }

    render() {
        const { detailsSummary, isProductValuationLoading, slideNumber } = this.state;
        const { isPresentationView } = this.context;
        return (
            <div
                className="mb-60"
                role={isPresentationView ? "main" : "tabpanel"}
                id="panel-0"
                tabIndex={0}
                aria-labelledby="tab-0"
            >
                <div className={`panel-subtle ${isPresentationView ? "mb-0 pb-10" : ""}`}>
                    {this.renderPieChartAndAccountTable()}
                </div>
                {!isPresentationView && (
                    <AccountCards
                        data={detailsSummary}
                        isLoading={isProductValuationLoading}
                        slideNumber={isPresentationView ? slideNumber : null}
                        hasReadWriteAccessToAdviser={this.props.hasReadWriteAccessToAdviser}
                    />
                )}
                {!isPresentationView && checkPermission(UserClaim.AdviserPortalPerformanceChargesCanView) && (
                    <button
                        className="hyperlink"
                        onClick={() => {
                            Navigator.navigateTo(
                                Urls.get().main.PortfolioDashboard({
                                    hierarchyId: ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
                                }).transactions,
                                {
                                    scrollAfterNavigating: true,
                                    queryParamsObject: {
                                        transtypeselect: TransactionEnum.charges,
                                    },
                                }
                            );
                        }}
                    >
                        View charges transactions
                    </button>
                )}
            </div>
        );
    }
}
PortfolioDashboardSummary.contextType = PresentationContext;
